import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";

import { ResponsiveContainer } from "scmp-app/components/header/features/styles";

import LogoIcon from "./icon-my-news.svg";

export const Container = styled(ResponsiveContainer)`
  inline-size: 74px;
  block-size: 30px;
  padding-block-start: 7px;
  padding-inline: 7px;

  text-align: center;

  border: 1px solid #001246;
  border-radius: 2px;
`;

export const StyledBaseLink = styled(BaseLink)``;

export const StyledLogo = styled(LogoIcon)`
  inline-size: 58px;
  block-size: 17px;
  path {
    transition: fill 0.2s ease-in-out;
  }
`;
